<app-base-panel-card
    [headingText]="headingText"
    (mouseover)="onMouseOver()"
    (mouseout)="onMouseOut()"
>
    <h4 class="panel-card-body" title="{{getTooltipText()}}">
        <span data-test-selector="summary-roll-up-value"
            class="panel-card-main-text {{mainClass}}"
            [ngClass]="!displayFullValue  ? 'fade-in' : 'fade-out'">
            {{ formatAbbreviatedMainText() }}
        </span>
        <span data-test-selector="summary-roll-up-value"
            class="panel-card-main-text {{mainClass}}"
            [ngClass]="displayFullValue ? 'fade-in' : 'fade-out'" >
            {{ formatMainText() }}
        </span>
        <br>
        <small class="text-muted h6" data-test-selector="summary-roll-up-under-text">
            {{underText}}
        </small>
    </h4>
</app-base-panel-card>
